// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__jgfsg","mail":"footer_mail__awu6s"};